import './LoadingSonar.scss';

import classNames from 'classnames';
import { LoadingCircle } from './LoadingCircle';
import React from 'react';
import { Tooltip } from 'antd';

export interface LoadingSonarProps {
	className?: string;
	tooltip?: string;
}

export const LoadingSonar: React.FC<LoadingSonarProps> = ({ className, tooltip }) => {
	const classes = classNames('loading-sonar', className);

	const icon = <LoadingCircle className={classes} />;

	if (!tooltip) {
		return icon;
	}

	return (
		<Tooltip
			placement='bottom'
			title={ tooltip }>
			{ icon }
		</Tooltip>
	);
};
